import { Icon, ImageFallback, Notice, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Pressable } from 'native-base';
import React from 'react';

import { data } from '../../data';

type ItemType = 'list' | 'detail';

interface ItemProps {
  item: (typeof data)[0];
  type?: ItemType;
  onPress?: () => void;
}

export const Item: React.FC<ItemProps> = ({ item, type = 'list', onPress }) => {
  return (
    <Shadow level={1} w="full" borderRadius={BoxRadius.sm}>
      <VStack p={Spacing['inline.xxs']} space={Spacing['inline.xxxs']}>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack space={Spacing['inline.quarck']}>
            <Text variant="bold" fontSize={Typography['fontsize.xl']}>
              {item.category}
            </Text>
            <Text
              variant="semibold"
              fontSize={{ base: Typography['fontsize.lg'], sm: Typography['fontsize.md'] }}>
              {item.value}
            </Text>
          </VStack>
          <VStack
            space={Spacing['inline.quarck']}
            alignItems={{ base: 'flex-end', sm: 'flex-start' }}>
            <Text>Situação</Text>
            <Text variant="semibold">{item.status}</Text>
          </VStack>
        </HStack>
        <Box h="1px" w="full" bg="neutral.lightest" />
        <HStack space={Spacing['inline.xxxs']}>
          <ImageFallback src="" alt="image-consortium" width="30px" height="30px" />
          <VStack space={Spacing['inline.quarck']} flex={1}>
            <Text>{item.categoryName}</Text>
            <Text color="neutral.medium">Taxa de administração</Text>
          </VStack>
          <VStack space={Spacing['inline.quarck']} alignItems="flex-end">
            <HStack alignItems="center" space={Spacing['inline.quarck']}>
              <Text color="neutral.medium">{item.paymentsAmount} x</Text>
              <Text variant="semibold" color="neutral.black">
                {item.monthlyValue}
              </Text>
            </HStack>
            <Text color="neutral.medium">{item.adminTax}</Text>
          </VStack>
        </HStack>
        {type === 'detail' && (
          <Notice
            testId="consortium-detail-notice"
            type="alert"
            backgroundColor={Utils.ColorToken.WithOpacity(
              'feedback.gen.lightest',
              'opacity.medium'
            )}
            textObjects={[
              {
                text: 'O valor da parcela poderá sofrer alteração em caso de lance, inadimplência ou reajuste.',
                variant: 'regular',
              },
            ]}
          />
        )}
        <VStack
          space={Spacing['inline.quarck']}
          bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}
          px={Spacing['inline.xxs']}
          py={Spacing['inline.xxxs']}>
          {item.operations.map((operation) => (
            <HStack
              key={operation.id.toString()}
              alignItems="center"
              justifyContent="space-between">
              <Text color={'brand.primary.principal'}>{operation.type}</Text>
              <Text color={'brand.primary.principal'}>{operation.date}</Text>
            </HStack>
          ))}
        </VStack>
        {type === 'list' && onPress && (
          <Pressable testID="add-item-to-cart-icon-button" alignSelf="end" onPress={onPress}>
            <HStack alignItems="center" space={Spacing['inline.nano']}>
              <Text
                color={'brand.tertiary.principal'}
                variant="semibold"
                fontSize={Typography['fontsize.md']}>
                ACESSAR
              </Text>
              <Icon name="ArrowRight" size="xxxs" color={Color['brand.tertiary.principal']} />
            </HStack>
          </Pressable>
        )}
      </VStack>
    </Shadow>
  );
};
